export default "__VITE_ASSET__2ddc87f2__"